import React from 'react';
import PropTypes from 'prop-types';
import { Col, Dropdown, DropdownButton, Form, Row } from 'react-bootstrap-5';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckCircle, faTrash } from '@fortawesome/pro-solid-svg-icons';
import { faEye } from '@fortawesome/pro-solid-svg-icons';
import DownloadButton from '../download_button';
import { Checkbox } from 'components/ui/checkbox';
import { v4 as uuid } from 'uuid';
import { faCaretDown } from '@fortawesome/pro-regular-svg-icons';

export default function PhotoBulkActions({
  allSelected,
  bulkDownloadLink,
  disabled,
  itemNoun = 'photos',
  label = 'Property Photos',
  osHeader,
  showLimit,
  onBulkAttributeChange,
  onBulkDelete,
  onBulkDownload,
  onBulkPreview,
  onSelectAll
}) {
  const dropdownId = React.useRef(uuid());
  const selectAllLabel = allSelected ? `Unselect all ${itemNoun}` : `Select all ${itemNoun}`;

  return (
    <Row className={osHeader ? 'align-items-center flex-nowrap g-0 gap-3' : 'align-items-center'}>
      {!osHeader && (
        <Col>
          <h6>
            {label}
            {showLimit && (<small className="text-muted ms-2 limit-label">(Limit: 100)</small>)}
          </h6>
        </Col>
      )}
      <Col xs="auto">
        {osHeader ? (
          <Checkbox
            checked={allSelected}
            className="photo-select-all"
            label={selectAllLabel}
            onCheckedChange={onSelectAll}
          />
        ) : (
          <Form.Check
            checked={allSelected}
            className="text-accent"
            id={`${dropdownId.current}_toggle_all`}
            label={selectAllLabel}
            type="checkbox"
            onChange={onSelectAll}
          />
        )}
      </Col>
      <Col xs="auto">
        <DropdownButton
          id={dropdownId.current}
          title={<>Actions<FontAwesomeIcon icon={faCaretDown} /></>}
          variant="outline"
        >
          {typeof onBulkAttributeChange === 'function' && (
            <Dropdown.Item disabled={disabled} onClick={() => onBulkAttributeChange('syndicate', true)}>
              <FontAwesomeIcon className="me-2" fixedWidth icon={faCheckCircle}/>
              Approve for Syndication
            </Dropdown.Item>
          )}
          {onBulkPreview && (
            <Dropdown.Item disabled={disabled} onClick={onBulkPreview}>
              <FontAwesomeIcon className="me-2" fixedWidth icon={faEye}/>
              Preview
            </Dropdown.Item>
          )}
          {typeof onBulkDownload === 'function' && typeof bulkDownloadLink === 'string' && (
            <DownloadButton
              disabled={disabled}
              href={bulkDownloadLink}
              menuIconColor={false}
              menuIconSize="md"
              messageOverride="Download"
              type="MenuItem"
              onClick={onBulkDownload}
            />
          )}
          <Dropdown.Divider />
          <Dropdown.Item disabled={disabled} onClick={onBulkDelete}>
            <FontAwesomeIcon className="me-2" fixedWidth icon={faTrash}/>
            Delete
          </Dropdown.Item>
        </DropdownButton>
      </Col>
    </Row>
  );
}

PhotoBulkActions.propTypes = {
  allSelected: PropTypes.bool.isRequired,
  bulkDownloadLink: PropTypes.string,
  disabled: PropTypes.bool.isRequired,
  itemNoun: PropTypes.string,
  label: PropTypes.string,
  osHeader: PropTypes.bool,
  showLimit: PropTypes.bool.isRequired,
  onBulkAttributeChange: PropTypes.func,
  onBulkDelete: PropTypes.func.isRequired,
  onBulkDownload: PropTypes.func,
  onBulkPreview: PropTypes.func,
  onSelectAll: PropTypes.func.isRequired,
};
